import { Stack, styled } from '@mui/material';

export const Container = styled(Stack)(() => ({
  borderRadius: '1rem',
  backgroundColor: 'white',
  marginBottom: '1rem',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  border: '1px solid #F0F0F0',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const Title = styled(Stack)(({ theme }) => ({
  padding: '0.75rem 1rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& p': {
    margin: 0,
    color: theme.palette.grey[900],
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
  },
}));

export const Content = styled(Stack)(() => ({
  padding: '0.75rem 1rem 1rem 1rem',
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
}));
